import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ListSitePage } from './list-site';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    ListSitePage,
  ],
  imports: [
    IonicPageModule.forChild(ListSitePage),
    ComponentsModule
  ],
})
export class ListSitePageModule {}



// WEBPACK FOOTER //
// ./src/pages/list-site/list-site.module.ts